import Vue from 'vue';

const eventBus = new Vue();
eventBus.MODAL_SHOW = 'modal.show';
eventBus.MODAL_HIDE = 'modal.hide';
eventBus.DELETE_MODAL_SHOW = 'delete-modal.show';
eventBus.DELETE_MODAL_HIDE = 'delete-modal.hide';
eventBus.SCHEDULE_DOWNTIME = 'schedule-downtime.show';
eventBus.SCHEDULE_LIST = 'schedule-list.show';
eventBus.SCHEDULE_EDIT = 'schedule-edit.show';
eventBus.SCHEDULE_ALL = 'schedule-all.show';
eventBus.BILLING_EDIT = 'billing-edit.show';
eventBus.BILLING_EDIT_HIDE = 'billing-edit.hide';
eventBus.SUBSCRIPTION_EDIT = 'subscription-edit.show';
eventBus.OAS_RESULT_MODAL = 'oas-result-modal.show';
eventBus.OAS_UPLOAD_MODAL = 'oas-upload-modal.show';
eventBus.OAS_EDITOR_MODAL = 'oas-editor-modal.show';
eventBus.ORG_DOWNTIME = 'org-downtime.show';
eventBus.RETURN_SKIP = 'skip';
eventBus.RETURN_OK = true;

eventBus.showSaveConfirmDialog = async function _showSaveConfirmDialog(paramsIn = {}) {
  const params = {
    body: 'You have not saved your changes, do you want to save now?',
    okayText: 'Save API Call',
    okayBtnClass: 'btn-success',
    okayBtnIcon: 'glyphicon glyphicon-floppy-saved',
    skipBtn: true,
    skipText: 'Abandon changes',
    skipBtnClass: 'btn-danger',
    skipBtnIcon: 'glyphicon glyphicon-remove',
    ...paramsIn,
  };
  if (!this.isProjectEditor) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    eventBus.$emit(eventBus.MODAL_SHOW, {
      title: 'Are you sure?',
      ...params,
      callback: (okayed) => {
        if (okayed) {
          resolve(okayed);
        } else {
          reject();
        }
      },
    });
  });
};

eventBus.showConfirmDialog = async function _showConfirmDialog(params = {}) {
  return new Promise((resolve, reject) => {
    eventBus.$emit(eventBus.MODAL_SHOW, {
      title: 'Are you sure?',
      body: 'You have not saved your changes, are you sure you want to leave this page?',
      okayBtnClass: 'btn-danger',
      okayBtnIcon: 'glyphicon glyphicon-remove',
      ...params,
      callback: (okayed) => {
        if (okayed) {
          resolve(okayed);
        } else {
          reject();
        }
      },
    });
  });
};

export default eventBus;
